<div class="container my-4 pb-4">
    <div class="mb-4">
        <h3>{{ 'sign.title' | translate }}</h3>
        <p class="mb-4">{{ 'sign.description' | translate }}</p>
    </div>

    <a (click)="goBack()" class="d-flex align-items-center mb-5 btn green-link">
        <span class="material-icons mr-2">keyboard_backspace</span><span>&nbsp;&nbsp;{{'sign.back' | translate}}</span></a>

    <div class="alert alert-primary" role="alert" *ngIf="allSigned">
        <span class="font-weight-bold">{{ 'doc.notifications.information' | translate }}</span> {{ 'doc.notifications.signed_doc_info' | translate }}
    </div>

    <div class="table-container mb-4">
        <app-dynamic-table [hideSelection]="true" [columnNames]="columnsConfig$ | async" [tableData]="documents">
        </app-dynamic-table>
        <div class="container" *ngIf="!!documents[0].Signers.length">
            <h6 class="my-2">{{'sign.nominate_users.title' | translate }}</h6>
            <table class="table table-sm table-striped">
                <thead>
                    <tr>
                        <th scope="col">{{ 'sign.nominate_users.user' |
                            translate | uppercase }}</th>
                        <th scope="col"> {{ 'sign.nominate_users.date' |
                            translate | uppercase }}</th>
                        <th scope="col">{{ 'sign.nominate_users.signed' |
                            translate | uppercase }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of documents[0].Signers">
                        <td>{{user.UserName | uppercase }}</td>
                        <td>{{user.Status.toLowerCase() === 'signed' ? (user.LastModification | dateFormat:
                            'L HH:mm:ss') : '-'}}</td>
                        <td>{{'sign.nominate_users.status.'+user.Status | lowercase | translate}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="doc-container" #container>
        <div class="d-flex my-2">
            <button (click)="goSign()" class="btn btn-success icon-btn ms-auto"><span>{{'sign.scroll' |
                    translate}}</span>
                <span class="material-icons">keyboard_arrow_down</span></button>
        </div>
        <ng-container *ngFor="let d of pdfs">
            <pdf-viewer
            *ngIf="d.pdfUrl"
             [src]="d.pdfUrl" [autoresize]="true" [original-size]="true" [fit-to-page]="false"
             [show-borders]="false" [render-text]="true"
            style="display: block; width: 100%; height:800px;">
            </pdf-viewer>
        </ng-container>
    </div>
    <div #sign class="sign-container container mt-4">
        <form #signForm ngNativeValidate (submit)="stampSignatures()">
            <div class="row">
                <div class="form-group col-12 pb-3 signing" *ngFor="let currSign of signList">
                    <h6 for="signature">{{ 'sign.' +  currSign.type + '_sign' | translate }}</h6>
                    <hr>
                    <div [ngClass]="{'disabled': onPreview || postSign}"
                        (click)="onPreview || postSign ? null : createSign(content, currSign.type)" class="signature"
                        id="signature">
                        <span class="required-field" *ngIf="currSign.isRequiredSign && !(currSign.sign)">*</span>
                        <input type="text" [hidden]="true" [ngModel]="currSign.sign"
                            [ngModelOptions]="{standalone: true}" [required]="currSign.isRequiredSign">
                        <img *ngIf="currSign.sign" class="sign-image" src="{{currSign.sign}}" alt="">
                    </div>
                    <div class="aclaration-field d-flex flex-row-reverse justify-content-end">
                        <span class="text-danger" *ngIf="currSign.isRequiredPrintName && !(currSign.printName)">*</span>
                        <input *ngIf="currSign.showPrintName" #signAclaration="ngModel" 
                            [disabled]="onPreview || postSign || currSign.type=='nominate'"
                            [ngClass]="{'alert-border': signAclaration.invalid && signAclaration.touched}"
                            [required]="currSign.isRequiredPrintName" type="text" [(ngModel)]="currSign.printName"
                            maxlength="40" [ngModelOptions]="{standalone: true}"
                            placeholder="{{'sign.' +  currSign.type + '_type_ph' | translate}}"
                            class="print-name-input form-control">
                    </div>
                </div>
                <div class="btn-container my-2 col-12 d-flex flex-column flex-md-row align-items-center justify-content-between px-0 mt-2 gap-2">
                    <input type="text" *ngIf="!postSign" class="form-control sign-date ml-3 col-8 col-md-4 mb-4 mb-md-0 width-3"
                        value="{{today | uppercase}}" disabled [readonly]="true">
                    <div class="custom-control custom-switch" *ngIf="signAllPages && !allSigned">
                        <input class="custom-control-input" id="allPagesCheck" type="checkbox" [(ngModel)]="signAll" name="signAll" [disabled]="(!checkVisibilityFields() || !signForm.checkValidity()) || onPreview">
                        <label class="custom-control-label" for="allPagesCheck">{{'table.buttons.signAllPages' | translate}}</label>
                    </div>
                    <div *ngIf="postSign"
                        class="action-btns d-flex flex-column pl-md-3 flex-md-row justify-content-md-between gap-2">
                        <button type="button" class="btn btn-success mb-2 mb-md-0 icon-btn" (click)="download()">
                            <span>{{'table.buttons.download' | translate}}</span>
                            <span class="material-icons">get_app</span>
                        </button>
                        <button type="button" class="btn btn-success ml-md-3 mb-2 mb-md-0 icon-btn" (click)="email()">
                            <span>{{'table.buttons.email' | translate}}</span>
                            <span class="material-icons">email</span>
                        </button>
                        <button type="button" class="btn btn-success ml-md-3 mb-2 mb-md-0 icon-btn" (click)="print()">
                            <span>{{'table.buttons.print' | translate}}</span>
                            <span class="material-icons">print</span>
                        </button>
                    </div>
                    <div [ngClass]="{'center': false}" class="sign-btns ml-md-3 d-flex flex-column flex-md-row gap-2">
                        <button type="submit" *ngIf="!onPreview && !allSigned" [disabled]="!checkVisibilityFields() || !signForm.checkValidity()" class="btn btn-success icon-btn mr-0 mr-md-2 mb-2 mb-md-0">
                            <span>{{'sign.preview' | translate }}</span>
                            <span class="material-icons">edit</span>
                        </button>

                        <button type="button" [disabled]="sending" *ngIf="onPreview && !postSign" class="btn btn-success icon-btn mr-0 mr-md-2 mb-2 mb-md-0" (click)="sendSignedDocs()">
                            <span>{{'sign.confirm' | translate }}</span>
                            <span class="material-icons">edit</span>
                        </button>
                        <button type="button" [disabled]="sending" [ngClass]="{'expand-back': false}" class="btn btn-success icon-btn" (click)="goBack(true)">
                            <span *ngIf="postSign" class="material-icons">chevron_left</span>
                            <span>{{ !postSign ? ('sign.cancel' | translate) : ('sign.go_back' | translate) }}</span>
                            <span *ngIf="!postSign" class="material-icons">cancel</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

<iframe #iframe width="420" height="345" [src]="pdfToPrint | safe">
</iframe>

<ng-template #content let-modal>
    <div class="modal-header d-flex align-items-center">
        <h4 *ngIf="!signed" class="modal-title" id="modal-basic-title">{{'sign.signature_pad_title' | translate}}</h4>
        <h4 *ngIf="signed" class="modal-title" id="modal-basic-title">Successfully Signed!</h4>
        <button type="button" class="btn ms-auto close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p *ngIf="signed">Ready for the next steps!</p>
        <app-signature-pad *ngIf="!signed" (sendSign)="getSign($event)" [modal]="modal" [currentSign]="currentSign"
            [withUpload]="authService.hasSigners()">
        </app-signature-pad>
    </div>
    <div *ngIf="signed" class="modal-footer">
        <button type="button" class="btn btn-success" (click)="closeModal()">Accept</button>
    </div>
</ng-template>

<app-mail-sender #mailSender [loading]="loading" (onSend)="sendDocs($event)"></app-mail-sender>

<!-- <ng2-pdfjs-viewer #pdfViewerOnDemand [externalWindow]="true" [downloadFileName]="'documents.pdf'" [openFile]="false"
    [viewBookmark]="false" [download]="false"></ng2-pdfjs-viewer> -->
    <pdf-viewer  #pdfViewerOnDemand  
                [autoresize]="true" 
                [original-size]="true" 
                [fit-to-page]="true"
                [show-borders]="true" 
                [render-text]="true" 
                style="display: block;"></pdf-viewer>